import {scriptonload} from '../modules/scriptonload';

var yt = function () {
	var init = function(){

	};

	scriptonload('https://apis.google.com/js/platform.js', init);
};

export {yt};
